import 'ckeditor5/ckeditor5.css';
function initTextEditor(element, options = {
    hideColors: false,
    fieldAttrs: {},
    allowImages: false,
    allowLinks: true,
    basicTextFormattingOnly: false,
}, onChange = null) {
    import('ckeditor5').then(CKE5 => {
        const plugins = [
            CKE5.Essentials,
            CKE5.Paragraph,
            CKE5.Bold,
            CKE5.Italic,
            CKE5.Underline,
            CKE5.Alignment,
            CKE5.PasteFromOffice,
            CKE5.Clipboard,
            CKE5.List,
            CKE5.HtmlEmbed,
        ];
        const config = {
            licenseKey: 'GPL',
            htmlEmbed: {
                showPreviews: true,
            },
            ...options.fieldAttrs,
        };
        const toolbar = [
            'Bold',
            'Italic',
            'Underline',
            '|',
            'alignment:left',
            'alignment:center',
            'alignment:right',
        ];
        if (options.allowLinks) {
            plugins.push(CKE5.AutoLink, CKE5.Link);
            toolbar.push('|', 'Link', 'Unlink');
        }
        if (!options.basicTextFormattingOnly) {
            plugins.push(CKE5.Heading, CKE5.FontSize);
            toolbar.push('|', 'Heading', 'FontSize');
        }
        if (!options.hideColors) {
            plugins.push(CKE5.FontColor, CKE5.FontBackgroundColor);
            toolbar.push('|', 'FontColor', 'fontBackgroundColor');
        }
        plugins.push(CKE5.RemoveFormat);
        toolbar.push('RemoveFormat');
        if (options.allowImages) {
            plugins.push(CKE5.Image, CKE5.SimpleUploadAdapter, CKE5.ImageUpload, CKE5.ImageInsert);
            toolbar.push('|', 'imageInsert');
            const fd = new FormData();
            window.csrf.addTokenToFormData(fd);
            const token = fd.get('csrfToken');
            config.simpleUpload = {
                uploadUrl: '/app/controllers/wysiwyg_images_controller.cfc?method=create',
                withCredentials: true,
                headers: {
                    'X-CSRF-Token': token,
                },
            };
        }
        plugins.push(CKE5.Fullscreen, CKE5.SourceEditing);
        toolbar.push('|', 'Fullscreen', '|', 'Undo', 'Redo', '|', 'SourceEditing', 'HtmlEmbed');
        CKE5.ClassicEditor.create(element, {
            ...config,
            toolbar,
            plugins,
        }).then(editor => {
            editor.model.document.on('change:data', () => {
                const data = editor.getData();
                if (onChange)
                    onChange(data);
            });
        });
    });
}
window.initTextEditor = initTextEditor;
